(function($) {
	formHelper.addRule({
		form: '.form-manage-coupon',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsManageCoupon($) {
	$('.manage-coupon-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-coupon');

		// Renewal Date Range
		// ------------------
		var $rewardDateFrom = $('#reward-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var rewardDateFromPicker = $rewardDateFrom.pickadate('picker');

		var $rewardDateTo = $('#reward-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var rewardDateToPicker = $rewardDateTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( rewardDateFromPicker.get('value') ) {
			rewardDateToPicker.set('min', rewardDateFromPicker.get('select'));
		}
		
		if ( rewardDateToPicker.get('value') ) {
			rewardDateFromPicker.set('max', rewardDateToPicker.get('select'));
		}

		// When something is selected, update the "rewardDateFrom" and "rewardDateTo" limits.
		rewardDateFromPicker.on('set', function(event) {
			if ( event.select ) {
				rewardDateToPicker.set('min', rewardDateFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				rewardDateToPicker.set('min', false);
			}
		});

		rewardDateToPicker.on('set', function(event) {
			if ( event.select ) {
				rewardDateFromPicker.set('max', rewardDateToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				rewardDateFromPicker.set('max', false);
			}
		});

		// Expiration Date Range
		// ------------------
		var $expirationDateFrom = $('#expiration-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var expirationDateFromPicker = $expirationDateFrom.pickadate('picker');

		var $expirationDateTo = $('#expiration-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var expirationDateToPicker = $expirationDateTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( expirationDateFromPicker.get('value') ) {
			expirationDateToPicker.set('min', expirationDateFromPicker.get('select'));
		}
		
		if ( expirationDateToPicker.get('value') ) {
			expirationDateFromPicker.set('max', expirationDateToPicker.get('select'));
		}

		// When something is selected, update the "expirationDateFrom" and "expirationDateTo" limits.
		expirationDateFromPicker.on('set', function(event) {
			if ( event.select ) {
				expirationDateToPicker.set('min', expirationDateFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				expirationDateToPicker.set('min', false);
			}
		});

		expirationDateToPicker.on('set', function(event) {
			if ( event.select ) {
				expirationDateFromPicker.set('max', expirationDateToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				expirationDateFromPicker.set('max', false);
			}
		});


		// Renewal Date Range
		// ------------------
		var $redemptionDateFrom = $('#redemption-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var redemptionDateFromPicker = $redemptionDateFrom.pickadate('picker');

		var $redemptionDateTo = $('#redemption-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var redemptionDateToPicker = $redemptionDateTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( redemptionDateFromPicker.get('value') ) {
			redemptionDateToPicker.set('min', redemptionDateFromPicker.get('select'));
		}
		
		if ( redemptionDateToPicker.get('value') ) {
			redemptionDateFromPicker.set('max', redemptionDateToPicker.get('select'));
		}

		// When something is selected, update the "redemptionDateFrom" and "redemptionDateTo" limits.
		redemptionDateFromPicker.on('set', function(event) {
			if ( event.select ) {
				redemptionDateToPicker.set('min', redemptionDateFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				redemptionDateToPicker.set('min', false);
			}
		});

		redemptionDateToPicker.on('set', function(event) {
			if ( event.select ) {
				redemptionDateFromPicker.set('max', redemptionDateToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				redemptionDateFromPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsManageAddCoupon($) {
	$('.add-coupon-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-add-coupon');

		// Expiration Date
		// ------------------
		var $expirationDate = $('#expiration-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var expirationDatePicker = $expirationDate.pickadate('picker');
	});
});

jQuery(function initToolsManageEditCoupon($) {
	$('.edit-coupon-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-coupon');

		// New Expiration Date
		// ------------------
		var $newExpirationDate = $('#new-expiration-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var newExpirationDatePicker = $newExpirationDate.pickadate('picker');
	});
});

jQuery(function initToolsManageCouponResults($) {
	$('.manage-coupon-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-coupon-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});


jQuery(function($){
	$('.js-coupon-actions').change(function() {
		if($(this).val() !== '') {
			document.location.href = $(this).val();
		}
	})
});

